import styled from 'styled-components';
import { media } from '../../helper';

export const Content = styled.section`
  & h2 {
    margin-top: 100px;
    margin-bottom: 48px;
    text-align: center;
    font-size: 60px;
  }

  & h3 {
    font-size: 36px;
    margin-bottom: 40px;
    text-align: center;
  }

  ${media.large} {
    & h2 {
      font-size: 56px;
      margin-bottom: 32px;
    }
  }

  ${media.medium} {
    & h2 {
      font-size: 40px;
      margin-bottom: 24px;
      margin-top: 0;
    }

    & h3 {
      font-size: 18px;
    }
  }
`;

export const OfficesList = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 72px;

  & > .list {
    width: 500px;
  }

  & .title {
    font-size: 48px;
    margin-bottom: 40px;
  }

  & .item:not(:last-child) {
    margin-bottom: 40px;
  }

  & .item .name {
    display: flex;
    align-items: center;
    color: #00843d;
    font-size: 40px;
    margin-bottom: 24px;
  }

  & .item .name > img {
    margin-right: 16px;
  }

  & .item .text {
    font-size: 20px;
  }

  @media (max-width: 1080px) {
    flex-direction: column;
    margin-top: 56px;

    & > .list {
      width: 100%;
    }

    & > .list:first-child {
      margin-bottom: 64px;
    }
  }

  ${media.small} {
    & .title {
      font-size: 32px;
      margin-bottom: 32px;
    }

    & .item .name {
      display: flex;
      align-items: center;
      color: #00843d;
      font-size: 24px;
      margin-bottom: 18px;
    }

    & .item .text {
      font-size: 16px;
    }

    & .item .name > img {
      width: 24px;
    }
  }
`;
